export default __webpack_public_path__ + "static/muli-v20-latin-regular-194389e05460566b2d7e442e5c848370.ttf";